import { StackProps } from '@chakra-ui/layout/dist/types/stack'
import { Heading, HStack } from '@chakra-ui/react'
import { uniqueId } from 'lodash'
import React, { forwardRef, Fragment, Ref } from 'react'
import { Pipe } from './Pipe'

interface HeadingToolbarProps extends StackProps {
  title?: string
  children?: JSX.Element[]
}

const HeadingToolbar = forwardRef(
  (props: HeadingToolbarProps, ref: Ref<HTMLDivElement>) => {
    const { title, children } = props
    return (
      <HStack
        {...props}
        ref={ref}
        bg="blue.900"
        textColor="white"
        fontWeight="bold"
        className="table-header"
        justifyContent="space-between"
        alignItems="center"
        paddingLeft="1rem"
        paddingRight="1rem"
      >
        {title && (
          <Heading as="h6" fontSize="1rem">
            {title}
          </Heading>
        )}
        {children && (
          <HStack className="table-toolbar" alignItems="center">
            {children.map((toolbarChild, index) => {
              return (
                <Fragment key={uniqueId(`${index}`)}>
                  {toolbarChild}
                  {index < children.length - 1 && <Pipe />}
                </Fragment>
              )
            })}
          </HStack>
        )}
      </HStack>
    )
  }
)

export default HeadingToolbar
